import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "api",
  "use": "api-usage",
  "viewBox": "0 0 46 49",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46 49\" id=\"api\"><path d=\"M27.59 18.006l7.5 7.5-7.5 7.5m-9-15l-7.5 7.5 7.5 7.5M44 43.506a3 3 0 01-3 3H5a3 3 0 01-3-3v-39a3 3 0 013-3h30.09a3 3 0 012.096.854l5.91 5.764A3 3 0 0144 10.272v33.234z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/api.svg
// module id = c2cN
// module chunks = 39 44